import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const newTicketStyles = StyleSheet.create({
	popup: {
		maxWidth: 600,
		'@media (max-width: 767px)': {
			width: '100vw',
			maxWidth: '100vw',
			height: '100dvh',
			maxHeight: '100dvh',
			borderRadius: 0,
		},
	},
	phoneCallRow: {
		alignSelf: 'flex-start',
		gap: THEME.spacing.sm,
		fontWeight: THEME.typography.fontWeights.standard,
		cursor: 'pointer',
	},
	fieldRow: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: THEME.spacing.md,
		'@media (max-width: 767px)': { gridTemplateColumns: 'minmax(0, 1fr)' },
	},
	csmRow: {
		marginTop: THEME.spacing.xs,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	descriptionEditor: {
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		minHeight: 110,
		maxHeight: 280,
		overflowY: 'auto' as const,
		cursor: 'text',
		':focus-within': {
			borderColor: THEME.colors.primary.main,
		},
	},
	selectTrigger: {
		width: '100%',
	},
	manualLink: {
		alignSelf: 'flex-start',
		padding: 0,
		height: 'auto',
		fontSize: THEME.typography.fontSizes.xs,
	},
	noContactWarning: {
		color: THEME.colors.text.main,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	draftHint: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	// FieldError is the only Field part without a line-height, so it swaps in shorter than the
	// FieldDescription it replaces and the dialog changes height mid-edit.
	contactError: {
		lineHeight: 1.5,
	},
	attachRow: {
		display: 'flex',
		alignItems: 'baseline',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.xs,
	},
	fileInput: {
		display: 'none',
	},
});
